export const required = value => {
    if (!value) {
      return 'Required';
    }
    if (typeof value === 'string' && !value.trim()) {
      return 'Required';
    }
    if (Array.isArray(value) && !value.length) {
      return 'Required';
    }
    return undefined;
  };
  export const maxLength = max => value =>
    value && value.length > max ? `Must be ${max} characters or less` : undefined;
  export const maxLength15 = maxLength(15);
  export const minLength = min => value =>
    value && value.length < min ? `Must be ${min} characters or more` : undefined;
  export const minLength2 = minLength(2);
  export const number = value =>
    value && isNaN(Number(value)) ? 'Must be a number' : undefined;
  export const minValue = min => value =>
    value && value < min ? `Must be at least ${min}` : undefined;
  export const minValue13 = minValue(13);
  export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
      ? 'Invalid email address'
      : undefined;
  export const phoneNumber = value =>
    value && !/^(0|[1-9][0-9]{9})$/i.test(value) && value[0]!==0
      ? 'Please provide valid 10 digits mobile number'
      : undefined;
  export const string = value =>
    value &&  !/^[a-zA-Z]*$/g.test(value)
        ? 'Invalid'
        : undefined;  
   export const maxLengthCheck = (max, value) =>
   value && value.length > max ? `Must be ${max} characters or more` : undefined;        

     
  


// WEBPACK FOOTER //
// ./web/util/validate.js